module.exports = __webpack_public_path__ + "img/60.57205e9e.jpg";